// ============================================================
// RADIOS
// ============================================================

import { radioBass } from "./radioBass"
import { radioBrazilian } from "./radioBrazilian"
import { radioPop } from "./radioPop"
import { radioReggaeton } from "./radioReggaeton"
import { radioWorld } from "./radioWorld"

// ============================================================
// ÍNDICE DE RADIOS
// ============================================================

export const radios = {
  bass: radioBass,
  brazilian: radioBrazilian,
  pop: radioPop,
  reggaeton: radioReggaeton,
  world: radioWorld,
}

// ============================================================
// PROGRAMACIÓN SEMANAL GLOBAL
//
// Une los programas de las 5 radios.
//
// Cada radio mantiene su propia programación:
// radioBass.lunes
// radioBrazilian.lunes
// etc.
//
// El hook puede buscar todos los programas
// del día actual desde aquí.
// ============================================================

export const programacionSemanal = {
  lunes: [
    ...radioBass.lunes,
    ...radioBrazilian.lunes,
    ...radioPop.lunes,
    ...radioReggaeton.lunes,
    ...radioWorld.lunes,
  ],

  martes: [
    ...radioBass.martes,
    ...radioBrazilian.martes,
    ...radioPop.martes,
    ...radioReggaeton.martes,
    ...radioWorld.martes,
  ],

  miercoles: [
    ...radioBass.miercoles,
    ...radioBrazilian.miercoles,
    ...radioPop.miercoles,
    ...radioReggaeton.miercoles,
    ...radioWorld.miercoles,
  ],

  jueves: [
    ...radioBass.jueves,
    ...radioBrazilian.jueves,
    ...radioPop.jueves,
    ...radioReggaeton.jueves,
    ...radioWorld.jueves,
  ],

  viernes: [
    ...radioBass.viernes,
    ...radioBrazilian.viernes,
    ...radioPop.viernes,
    ...radioReggaeton.viernes,
    ...radioWorld.viernes,
  ],

  sabado: [
    ...radioBass.sabado,
    ...radioBrazilian.sabado,
    ...radioPop.sabado,
    ...radioReggaeton.sabado,
    ...radioWorld.sabado,
  ],

  domingo: [
    ...radioBass.domingo,
    ...radioBrazilian.domingo,
    ...radioPop.domingo,
    ...radioReggaeton.domingo,
    ...radioWorld.domingo,
  ],
}